import * as _ from "lodash";

export const toCamelCase: any = (obj: object | Array<any> | undefined | null | any) => {
    if (!obj) {
        return obj;
    }

    if (typeof obj === "object") {
        if (obj instanceof Array) {
            return obj.map(toCamelCase);
        }

        const rtn: any = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                rtn[_.camelCase(key)] = toCamelCase(obj[key]);
            }
        }

        return rtn;
    }

    return obj;
};

export const toSnakeCase: any = (obj: any) => {
    if (!obj) {
        return obj;
    }

    if (typeof obj === "object") {
        if (obj instanceof Array) {
            return obj.map(toSnakeCase);
        }

        const rtn: any = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                rtn[_.snakeCase(key)] = toSnakeCase(obj[key]);
            }
        }

        return rtn;
    }

    return obj;
};

export const sortArrayOfObjectWithStrings = (arr: Array<any>, key: string) => {
    return arr.sort((a, b) => {
        if (
            a[key]
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "") <
            b[key]
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
        )
            return -1;
        if (
            a[key]
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "") >
            b[key]
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
        )
            return 1;
        return 0;
    });
};

export function arrayOfObjectAreEqual(
    arr1?: Array<Object> | null,
    arr2?: Array<Object> | null
): boolean {
    return (
        (!arr1 && !arr2) ||
        (!!arr1 &&
            !!arr2 &&
            arr1.length === arr2.length &&
            arr1.every((el1) =>
                arr2.some((el2) =>
                    Object.keys(el1).every(
                        (key) => el1[key as keyof typeof el1] === el2[key as keyof typeof el2]
                    )
                )
            ))
    );
}
